import Reveal from "./Reveal";

// =====================================================================
// TROQUE AQUI quando vier o resumo oficial do app:
// copy provisória dos destaques do EscapeFlow. o print largo aponta pra
// public/escape21/app-feature-1.png (placeholder até o arquivo existir).
// =====================================================================
const FEATURES = [
  {
    title: "check-in diário",
    body: "um toque e tá marcado. teu dia registrado em segundos.",
  },
  {
    title: "sequência",
    body: "tua constância vira um número que tu não vai querer zerar.",
  },
  {
    title: "ranking do desafio",
    body: "teu progresso do lado da galera, dia após dia.",
  },
  {
    title: "Kore",
    body: "assistente de IA dentro do app, pronto pra te ajudar no que travar.",
  },
];

/** continuação da seção escura: o que o EscapeFlow faz, resumido */
const AppFeatures = () => (
  <section className="bg-[#0A0A0A] px-6 pb-20 pt-4 text-white sm:pb-28">
    <div className="mx-auto max-w-4xl">
      <div className="grid gap-4 sm:grid-cols-2">
        {FEATURES.map((feature, i) => (
          <Reveal key={feature.title} delay={i * 90}>
            <div className="e21-glass-dark h-full rounded-2xl p-6 transition-all duration-300 hover:-translate-y-1 hover:bg-white/10 sm:p-7">
              <h3 className="text-lg font-bold tracking-[-0.02em] sm:text-xl">
                {feature.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-white/60 sm:text-base">
                {feature.body}
              </p>
            </div>
          </Reveal>
        ))}
      </div>

      {/* print real da versão desktop, inteiro (sem corte) */}
      <Reveal delay={200} className="mt-4">
        <img
          src="/escape21/telahomeappversaopc.jpg"
          alt="EscapeFlow rodando no navegador"
          loading="lazy"
          className="h-auto w-full rounded-2xl border border-white/10 bg-[#161616]"
        />
        <p className="mt-3 text-center font-mono text-[11px] uppercase tracking-[0.25em] text-white/35">
          no celular e no navegador
        </p>
      </Reveal>

      <Reveal delay={280}>
        <p className="mt-12 text-center text-xl font-bold leading-snug tracking-[-0.02em] sm:text-2xl">
          o app <span className="e21-serif">sozinho</span> já valia mais que o
          preço do desafio.
        </p>
      </Reveal>
    </div>
  </section>
);

export default AppFeatures;
